//==============================================================================
// Wrapper for localStorage with fallback to sessionStorage or in-memory storage
// with JSON serialization/deserialization. Keys should be strings.
//==============================================================================

import { uuid } from "./misc"


const storage = init()


export function getData(key) {
  const rawData = storage.getItem(key)
  try {
    return JSON.parse(rawData)
  } catch (e) {
    return rawData || ''
  }
}


export function setData(key, value) {
  if (value === undefined) {
    storage.removeItem(key)
  }
  else {
    const rawData = JSON.stringify(value)
    storage.setItem(key, rawData)
  }
}


export function delData(key) {
  storage.removeItem(key)
}


function init() {
  let store = null

  if (typeof window !== 'undefined') {
    store ||= ifValid(window.localStorage)
    store ||= ifValid(window.sessionStorage)
  }

  store ||= ifValid(MapStorage())
  store ||= HashStorage()

  // // FIXME: Use a no-op store to show that login break
  // store = {
  //   getItem:    (key)        => {},
  //   setItem:    (key, value) => {},
  //   removeItem: (key)        => {},
  //   clear:      ()           => {},
  // }

  return store
}


// NOTE: Do NOT use `new` when calling this function
function MapStorage() {
  const map = new Map()

  return {
    getItem:    (key)        => map.get(key),
    setItem:    (key, value) => map.set(key, value),
    removeItem: (key)        => map.delete(key),
    clear:      ()           => map.clear(),
  }
}


// NOTE: Do NOT use `new` when calling this function
function HashStorage() {
  let hash = {}

  return {
    getItem:    (key)        => hash[key],
    setItem:    (key, value) => hash[key] = value,
    removeItem: (key)        => delete hash[key],
    clear:      ()           => hash = {},
  }
}


function ifValid(storage) {
  return isValid(storage) ? storage : null
}


function isValid(storage) {
  try {
    const testKey = uuid()
    const testValue = '__test_value__'

    storage.setItem(testKey, testValue)
    const loadedValue = storage.getItem(testKey)
    storage.removeItem(testKey)

    if (loadedValue === testValue) {
      return true
    }
  } catch (e) {
    // Ignore errors
  }
}